import "./openTicketSingleid.scss";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import newRequest from "../../../context/newRequest";
import useFetch from "../../../hooks/useFetch";
import useVendors from "../../../hooks/useVendors";
import useRegions from "../../../hooks/useRegions";

const categoryOptions = [
  { value: "Internal Distribusi Issue", label: "Internal Distribusi Issue" },
  { value: "Vendor Device Problem", label: "Vendor Device Problem" },
  { value: "Electrical Issue", label: "Electrical Issue" },
  { value: "ONUBAD", label: "ONU Bad" },
  { value: "FIBERCUT", label: "Fiber Cut" },
  { value: "INTERMITTEN", label: "INTERMITTEN" },
  { value: "LOOPING", label: "LOOPING" },
  { value: "BENDING", label: "BENDING" },
  { value: "MAINTENANCE", label: "Maintenance" },
];

const OpenTicketSingleID = () => {
  const [ticketOpen, setTicketOpen] = useState({});
  const [categoryId, setCategoryId] = useState([]);
  const [regionId, setRegionId] = useState(["JABODETABEK"]);
  const [sending, setSending] = useState("");
  const [localSite, setLocalSite] = useState({});
  const { regions } = useRegions();
  const { vendors } = useVendors();

  const { siteId } = useParams();
  const navigate = useNavigate();
  const { data } = useFetch(`/localsite/${siteId}`);

  useEffect(() => {
    if (data) {
      setLocalSite(data);
    }
  }, [data]);

  const handleSelectRegionID = (e) => {
    const value = Array.from(
      e.target.selectedOptions,
      (option) => option.value
    );
    setRegionId(value);
  };

  const handleSelectCategoryID = (e) => {
    const value = Array.from(
      e.target.selectedOptions,
      (option) => option.value
    );
    setCategoryId(value);
  };

  const handleChange = (e) => {
    setTicketOpen((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      setSending("On Submit");
      const userObj = JSON.parse(localStorage.getItem("user") || "{}");

      const newTicketOpen = {
        ...ticketOpen,
        region_id: regionId[0],
        category_id: categoryId[0],
      };

      const res = await newRequest.post(`/ticketlocal/${siteId}`, newTicketOpen, {
        headers: {
          Authorization: `Bearer ${userObj.token || ""}`,
        },
      });

      setSending("Mengirim Submit");

      if (res.status === 200) {
        setSending("Submit berhasil");
        navigate(`/ticketsite/${res.data?.data?.id}`);
      }
    } catch (err) {
      const errorMsg = err.response?.data?.errors || err.message || "Terjadi kesalahan";
      setSending(typeof errorMsg === "object" ? JSON.stringify(errorMsg) : errorMsg);
      console.log(err.response?.data);
    }
  };

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>Open Ticket With Site ID</h1>
        </div>

        <h2>Site Name : {localSite.name_site}</h2>
        <h2>POP ID: {localSite.pop_id}</h2>

        <div className="bottom">
          <div className="right">
            <form>
              <div className="formInput">
                <label className="label">Vendor ID</label>
                <select id="vendor_id" value={ticketOpen.vendor_id || ""} onChange={handleChange}>
                  <option value="">Pilih Vendor Id</option>
                  {vendors.map((vendor) => (
                    <option key={vendor.id} value={vendor.id}>
                      {vendor.id}
                    </option>
                  ))}
                </select>

                <label>Root Cause</label>
                <input
                  id="root_cause"
                  placeholder="Root Cause"
                  value={ticketOpen.root_cause || ""}
                  onChange={handleChange}
                />

                <label>Action</label>
                <input
                  id="action"
                  placeholder="Action"
                  value={ticketOpen.action || ""}
                  onChange={handleChange}
                />

                <label>Note</label>
                <input
                  id="note"
                  placeholder="Catatan / Note"
                  value={ticketOpen.note || ""}
                  onChange={handleChange}
                />

                <label className="label">Category ID</label>
                <select id="category_id" onChange={handleSelectCategoryID}>
                  <option value="">Pilih Category Id</option>
                  {categoryOptions.map((cat, idx) => (
                    <option key={idx} value={cat.value}>
                      {cat.label}
                    </option>
                  ))}
                </select>

                <label className="label">Region ID default: JABODETABEK</label>
                <select id="region_id" onChange={handleSelectRegionID}>
                  <option value="">Pilih Region Id</option>
                  {regions.map((reg, idx) => (
                    <option key={reg.id || idx} value={reg.id}>
                      {reg.id} {reg.description ? `(${reg.description})` : ""}
                    </option>
                  ))}
                </select>
              </div>
            </form>
            <button onClick={handleClick}>Send</button>
          </div>
        </div>

        {sending && <p className="error">{sending}</p>}
      </div>
    </div>
  );
};

export default OpenTicketSingleID;

